import { CircularProgress } from '@carrier-io/air-react';

export const Loader = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <CircularProgress color="primary" size={80} thickness={3.6} value={100} variant="indeterminate" />
    </div>
  );
};
